export default __webpack_public_path__ + "assets/models/4565c0263eff45fa434b16d46f656b7c.glb";